var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th'):_c('td',{staticClass:"expand-indicator-cell",on:{"click":_vm.onClick}},[_c('i',{staticClass:"expand-hint-icon",class:_vm.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-870a5a58","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueTableExpandIndicator.vue
// module id = 1335
// module chunks = 86